import { useEffect } from "react";
import {
  Form,
  Flex,
  Button,
  Input,
  Switch,
  Select,
  ConfigProvider,
} from "antd";

import StyledModal from "./style";

import { RISK_TYPES_LEVEL } from "../../../../../proposal/constant";
import { OPTIONS_INVESTMENT_OBJECTIVE } from "../../../../constant";

const ModalModelSettings = ({
  activeModelData,
  loading,
  onCancel,
  onSuccess,
  open,
  startWithTemplate,
  templateList,
  title,
}) => {
  const [form] = Form.useForm();

  const useTemplate = Form.useWatch("useTemplate", form);

  useEffect(() => {
    if (!open) return;

    form.resetFields();
    form.setFieldsValue({
      name: activeModelData?.name,
      useTemplate: startWithTemplate,
    });
  }, [open]);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formNewModel"
            htmlType="submit"
            shape="round"
            type="primary"
          >
            Continue
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title={title}
      width={435}
    >
      <ConfigProvider
        theme={{
          components: {
            Switch: {
              colorPrimary: "#019A00",
              colorPrimaryHover: "#019A00",
            },
          },
        }}
      >
        <Form
          form={form}
          id="formNewModel"
          layout="vertical"
          onFinish={onSuccess}
        >
          <Form.Item
            label="Name"
            name="Name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Flex>
            <Form.Item
              colon={false}
              hidden={activeModelData || !startWithTemplate}
              label="Use a Template"
              labelCol={{ style: { marginLeft: 6, order: 2 } }}
              layout="horizontal"
              name="useTemplate"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Flex>

          {useTemplate && (
            <Flex className="container-template-options" gap={16} vertical>
              <b>Template Options</b>

              <Form.Item
                label="Risk Category"
                name="templateId"
                rules={[{ required: true }]}
              >
                <Select
                  options={templateList?.map(it => ({
                    label: it.RiskType,
                    value: it._id,
                  }))}
                />
              </Form.Item>
              <Form.Item
                label="Investment Objective"
                name="planningObjective"
                rules={[{ required: true }]}
              >
                <Select options={OPTIONS_INVESTMENT_OBJECTIVE} />
              </Form.Item>
            </Flex>
          )}
        </Form>
      </ConfigProvider>
    </StyledModal>
  );
};

export default ModalModelSettings;
